/**
 * useMetrics.js - Hook para cargar métricas del backend
 * OPTIMIZADO: Solo trae contadores, no documentos completos
 */
import { useState, useCallback } from 'react';

export const useMetrics = () => {
  const [metrics, setMetrics] = useState({
    inactivos: 0,
    pendientePorLigar: 0,
    impresos: 0,
    entregados: 0,
    activos: 0,
    perdidos: 0,
    porVencer: 0,
    vencidos: 0,
    total: 0
  });
  const [loading, setLoading] = useState(false);

  const loadMetrics = useCallback(async (user = null) => {
    setLoading(true);
    try {
      let token = localStorage.getItem('authToken') || localStorage.getItem('nfcToken');
      
      // ✅ Si no hay token en localStorage pero hay usuario, obtenerlo de Firebase
      if (!token && user) {
        try {
          token = await user.getIdToken();
        } catch (error) {
          console.error('[useMetrics] Error obteniendo token de usuario:', error);
        }
      }
      
      if (!token) {
        console.error('[useMetrics] No hay token de autenticación disponible');
        return metrics;
      }
      
      // Llamar al endpoint de métricas
      const response = await fetch('/api/admin/metricas', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP ${response.status}`);
      }
      
      const resultado = await response.json();
      const newMetrics = resultado.data || {};

      setMetrics(newMetrics);
      return newMetrics;
      
    } catch (error) {
      console.error('[useMetrics] Error cargando métricas:', error);
      return metrics;
    } finally {
      setLoading(false);
    }
  }, []);

  return { metrics, loadMetrics, loading };
};